import transaction from '@apis/transaction'
import { outlinewallet } from '@assets/icons'
import Status from '@components/status'
import Table from '@components/table'
import { RootState } from '@store/index'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import DateRangeFilter from '@components/table/DateRangeFilter'
import StatusFilter from '@components/table/StatusFilter'
import styled from '@emotion/styled'

const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    width: 100%;
  }
`

const PointTransferList = () => {
  const {
    items: TransferLists = [],
    totalItems,
    totalPages,
    loading,
  } = useSelector((state: RootState) => state.transactions)
  const [searchTerm, setSearchTerm] = useState('')
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [status, setStatus] = useState('')
  const [page, setPage] = useState(1)
  const fetchTransactions = async (search = '') => {
    try {
      await transaction.list({
        state: 'transactions',
        params: {
          page,
          limit: 30,
          type: 'Transfer',
          ...(search && { search }),
          ...(fromDate && { startDate: fromDate }),
          ...(toDate && { endDate: toDate }),
          ...(status && { status }),
        },
      })
    } catch (error) {
      console.error('Error fetching transactions:', error)
    }
  }
  const pointtransfercolumn = [
    {
      title: 'User',
      key: 'user',
    },
    {
      title: 'Email',
      key: 'email',
    },
    // {
    //   title: 'New Email',
    //   key: 'new_email',
    // },
    {
      title: 'Points',
      key: 'points',
    },
    {
      title: 'Request Date',
      key: 'request_date',
      render: (item) => (
        <div>
          <p>{item.created_date}</p>
          <p style={{ color: 'grey', fontSize: '12px' }}>{item.created_time}</p>
        </div>
      ),
    },
    {
      title: 'Status',
      key: 'status',
      render: (item) => (
        <Status
          item={item}
          statuses={['Pending', 'Delivered', 'Cancelled']}
          onStatusChange={async (status) => {
            await transaction.update({
              id: item.id,
              state: 'transactions',
              data: { status },
            })
          }}
        />
      ),
    },
  ]
  const pointtransferdata = TransferLists.map((t) => ({
    id: t?.id,
    user: t?.user?.name,
    email: t?.user?.email,
    points: t?.amount,
    created_date: t.createdAt ? t.createdAt.split('T')[0] : 'N/A',
    created_time: t.createdAt
      ? (() => {
          const [hour, min, sec] = t.createdAt
            .split('T')[1]
            .split('.')[0]
            .split(':')
          const h = Number(hour)
          const ampm = h >= 12 ? 'PM' : 'AM'
          const hour12 = h % 12 === 0 ? 12 : h % 12
          return `${hour12}:${min}:${sec} ${ampm}`
        })()
      : 'N/A',
    status: t?.status,
  }))
  useEffect(() => {
    setPage(1)
  }, [searchTerm, fromDate, toDate, status])
  useEffect(() => {
    fetchTransactions(searchTerm)
  }, [searchTerm, page, fromDate, toDate, status])
  return (
    <>
      <Table
        onSearchChange={(val) => {
          setSearchTerm(val)
        }}
        loading={loading}
        text="Points Transfer Request"
        icon={outlinewallet}
        columns={pointtransfercolumn}
        data={pointtransferdata}
        itemsPerPage={30}
        searchKeys={['name', 'number', 'amount']}
        totalItems={totalItems}
        totalPages={totalPages}
        pageControlled={page}
        onPageChange={setPage}
        rightSearchElement={
          <HeaderActions>
            <DateRangeFilter
              fromDate={fromDate}
              toDate={toDate}
              onFromDateChange={setFromDate}
              onToDateChange={setToDate}
            />
            <StatusFilter value={status} onChange={setStatus} />
          </HeaderActions>
        }
      />
    </>
  )
}

export default PointTransferList
